// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\UITheme\ApiUITheme.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// UIThemeData is the class that UITheme serializes to/from
export interface UIThemeData {
    Id : number;
	
	
    CssClasses : string;
    CssFile : string;
    Description : string;
    Name : string;
}

// UIThemeOptions is the class which may be passed to the UITheme constructor to define optional initial data values
export interface UIThemeOptions {
    Id : number;
	
	
    CssClasses? : string;
    CssFile? : string;
    Description? : string;
    Name? : string;
}

export class UITheme {
    public Id : DataSignal<number>;
	
	
    public CssClasses : DataSignal<string>;
    public CssFile : DataSignal<string>;
    public Description : DataSignal<string>;
    public Name : DataSignal<string>;

    constructor();
    constructor(data : UIThemeOptions);
    constructor(data: UIThemeOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
	    
        this.CssClasses = jsonableObservable(S.value<string>(data && data.CssClasses !== undefined ? data.CssClasses : ''));
        this.CssFile = jsonableObservable(S.value<string>(data && data.CssFile !== undefined ? data.CssFile : ''));
        this.Description = jsonableObservable(S.value<string>(data && data.Description !== undefined ? data.Description : ''));
        this.Name = jsonableObservable(S.value<string>(data && data.Name !== undefined ? data.Name : ''));
    }

    static key(obj : UITheme) {
        return obj.Id();
    }
    
    static dataKey(obj : UIThemeOptions) {
        return obj.Id;
    }

    static update(obj : UITheme, data : UIThemeOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
	        
            if (data.CssClasses !== undefined) obj.CssClasses(data.CssClasses);
            if (data.CssFile !== undefined) obj.CssFile(data.CssFile);
            if (data.Description !== undefined) obj.Description(data.Description);
            if (data.Name !== undefined) obj.Name(data.Name);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/UITheme.ts